import { render } from "./CreateRoom.vue?vue&type=template&id=11fd8f5e"
import script from "./CreateRoom.vue?vue&type=script&lang=ts"
export * from "./CreateRoom.vue?vue&type=script&lang=ts"
script.render = render

export default script